module.exports = __webpack_public_path__ + "static/media/wireframes.373d6652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/wireframes.jpg
// module id = 425
// module chunks = 0